/**
 * Cross Sell performance tracking component.
 *
 * @module app/components/crossSell/CrossSellAnalyticsTracking
 */

/**
 * Generic function for publishing events
 *
 * @param {String} Name of the event to publish
 * @param {Object} Event data to be published
 *
 * @returns {void}
 * @private
 */
var publishEvent = function publishEvent(eventName, eventData) {

    if (window.WH && window.WH.messageBus) {

        window.WH.messageBus.publish(eventName, eventData);
    }
};

/**
 * Returns the url based on the game type
 *
 * @param {object} game
 * @returns {*}
 */
var getUrlForGameType = function getUrlForGameType(game) {

    var gameTypes = {
        mobile: game.mobileUrl,
        desktop: game.desktopUrl,
        embedded: game.embeddedUrl,
    };

    return gameTypes[game.gameType];
};

/**
 * Publish an event stating that an app has been clicked on.
 *
 * @param {Object} Game object
 * @returns {void}
 * @private
 */
var publishAppLaunchEvent = function publishAppLaunchEvent(app) {

    var eventData = {
        app: true,
        funnel: app.funnel,
        location: app.location,
        name: app.name,
        position: app.position,
    };

    publishEvent('crossSellLaunch', eventData);
};

/**
 * Publish an event stating that a cross sell item is being launched.
 *
 * @param {Object} Game object
 * @returns {void}
 * @private
 */
var publishGameLaunchEvent = function publishGameLaunchEvent(game) {

    var eventData = {
        url: getUrlForGameType(game),
        position: game.position,
        name: game.name,
        location: game.location,
        funnel: game.funnel,
    };

    publishEvent('crossSellLaunch', eventData);
};


/**
 * Publish an event stating that a cross sell section product is being launched.
 *
 * @param {Object} Section object
 * @returns {void}
 * @private
 */
var publishSectionViewMoreEvent = function publishSectionViewMoreEvent(section) {

    publishEvent('crossSellViewMore', {
        location: section.location,
        sectionName: section.sectionName,
        sectionIndex: section.sectionIndex,
        sectionUrl: section.sectionUrl,
    });
};

/**
 * Contains functions exposed by this component as an API.
 *
 * @type {Object}
 *
 * @public
 */
export default {

    publishAppLaunchEvent: publishAppLaunchEvent,
    publishGameLaunchEvent: publishGameLaunchEvent,
    publishSectionViewMoreEvent: publishSectionViewMoreEvent,

};
